// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/UpSquareTwoTone";
import AntdIcon from '../components/AntdIcon';

var UpSquareTwoTone = function UpSquareTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareTwoToneSvg
  }));
};

UpSquareTwoTone.displayName = 'UpSquareTwoTone';
export default React.forwardRef(UpSquareTwoTone);